import { useQuery } from 'react-query'
import { api } from '../services/api'
import { useState } from 'react'

async function getValorVerba() {
  const response = await api.get('/chamado/listar-tipo-verbas')

  return response?.data?.map((item) => {
    return {
      value: item.id,
      label: item.valor,
    }
  })
}

export const useValorVerba = () => {
  const [listaValorVerba, setListaValorVerba] = useState([])

  const {
    data = [],
    isLoading,
    refetch,
  } = useQuery({
    queryKey: 'valor-verba',
    queryFn: getValorVerba,
    staleTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      setListaValorVerba(data)
    },
  })

  async function refetchValorVerba() {
    setListaValorVerba([])
    await refetch()
  }

  return { listaValorVerba, isLoading, refetchValorVerba }
}
